module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero-unit p3 py4 flex flex-wrap justify-center"
  }, [_c('div', {
    staticClass: "center flex flex-column justify-between"
  }, [_c('p', {
    staticClass: "tagline h1 m0",
    domProps: {
      "innerHTML": _vm._s(_vm.content.tagline)
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6095fc99","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HeroUnit.vue
// module id = 125
// module chunks = 0